import React, { useMemo, useCallback, useState, useEffect } from "react";
import PropTypes from "prop-types";
import SearchBar from "./SearchBar";

// 入力文字列を「半角/全角スペース区切り」でキーワード配列に変換
const convertSearchTextToKeywordArray = (searchText) => {
  return (searchText ?? "")
    .trim()
    .split(/[\s\u3000]+/g)
    .map((keyword) => keyword.trim())
    .filter(Boolean);
};

export default function SearchContainer({
  type = "project",
  value,
  onChange,
  onSearch,
  onOpenFilter
}) {

  // 親のkeywordから初期表示用の文字列を作る
  const initialInputText = useMemo(() => {
    if (typeof value?.keywordInputText === "string") return value.keywordInputText;
    return Array.isArray(value?.keyword) ? value.keyword.join(" ") : "";
  }, [value?.keywordInputText, value?.keyword]);

  // 入力中テキスト（スペース含めてそのまま保持）
  const [searchInputText, setSearchInputText] = useState(initialInputText);

  // 親側のkeywordが変わったら入力欄にも反映
  useEffect(() => {
    setSearchInputText(initialInputText);
  }, [initialInputText]);

  // 入力欄の変更：文字はそのまま保持
  const handleInputChange = useCallback(
    (event) => {
      const nextInputText = event?.target?.value ?? "";
      setSearchInputText(nextInputText);

      onChange?.({
        ...value,
        keywordInputText: nextInputText,
      });
    },
    [value, onChange]
  );

  // 検索実行：配列化して親に渡す
  const executeSearch = useCallback(() => {
    const keywordTextArray = convertSearchTextToKeywordArray(searchInputText);

    const nextSearchFilters = {
      ...value,
      keywordInputText: searchInputText,
      keyword: keywordTextArray,
    };

    onChange?.(nextSearchFilters);
    onSearch?.(nextSearchFilters);
  }, [searchInputText, value, onChange, onSearch]);

  // ×で検索バーの文字をクリア&検索（全件表示)
  const clearAndSearch = useCallback(() => {
    const clearedSearchFilters = {
      ...value,
      keywordInputText: "",
      keyword: [],
    };
  
    setSearchInputText("");
    onChange?.(clearedSearchFilters);
  }, [value, onChange, onSearch]);

  return (
    <SearchBar
      searchInputText={searchInputText}
      onInputChange={handleInputChange}
      onSearch={executeSearch}
      onClearSearch={clearAndSearch}
      type={type}
      onOpenFilter={onOpenFilter}
    />
  );
}

SearchContainer.propTypes = {
  type: PropTypes.string,
  value: PropTypes.object,
  onChange: PropTypes.func,
  onSearch: PropTypes.func,
  onOpenFilter: PropTypes.func,
};